// React mount for the CrewMagic dashboard. Reads bootstrap +
// translations out of the root element's data-* attributes before
// mounting, then constructs the React tree.

import { createRoot } from "react-dom/client"
import { App } from "./components/App"
import { readDashboardData } from "./lib/translations"
import { setCsrfToken } from "./lib/api"
import { initCompanyStore } from "./stores/companyStore"

export function mount(el) {
  readDashboardData(el)
  const bootstrap = JSON.parse(el.dataset.bootstrap || "{}")
  if (bootstrap.csrf_token) setCsrfToken(bootstrap.csrf_token)
  initCompanyStore(bootstrap)

  // Restore saved theme preference, if any.
  const savedTheme = localStorage.getItem("cm:theme")
  if (savedTheme) document.documentElement.setAttribute("data-theme", savedTheme)

  // Global "/" → focus search. Bail when the user is typing
  // anywhere — input, textarea, contenteditable, select — otherwise
  // a "/" inside a URL or sentence steals focus mid-type (caught
  // when a non-tech user was pasting a WMS URL into the agent-builder
  // chat and lost everything after the "//").
  document.addEventListener("keydown", (e) => {
    if (e.key !== "/") return
    const el = document.activeElement
    if (!el) {
      e.preventDefault()
      document.querySelector(".cm-search input")?.focus()
      return
    }
    const tag = el.tagName
    if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || el.isContentEditable) return
    e.preventDefault()
    document.querySelector(".cm-search input")?.focus()
  })

  const root = createRoot(el)
  root.render(<App />)
}
